<template lang="pug">
  modal(id="getKeyModal" name="getkeymodal" height="auto" :classes="['v--modal', 'vue-dialog', this.params.class]" :width="width" :pivot-y="0.3" :adaptive="true" :click-to-close="clickToClose" :transition="transition" @before-open="beforeOpened" @before-close="beforeClosed" @opened="$emit('opened', $event)" @closed="$emit('closed', $event)")
    form.dialog-content(style="text-align: center;" id="login")
      .dialog-c-title(v-if="params.title" v-html="params.title || ''")
      .input.token(v-if="input")
        input#username.inputclass(type="text" name="username" :disabled="true" v-model="inputuser")
        input.inputclass(:type="switchType" name="password" von:keydown="pasteToken"  :placeholder="input" v-model="inputmodel")
        i(:class="hideToken" v-on:click="showToken()" v-tooltip="switchType === 'text' ? 'Hide Token' : 'Show Token'")
      component(v-if="params.component" v-bind="params.props" :is="params.component")
      .dialog-c-text(v-else="" v-html="params.text || ''")
    .vue-dialog-buttons(v-if="buttons")
      button(v-for="(button, i) in buttons" :class="button.class || 'vue-dialog-button'" ref="buttons" :id="'button-dialog-' + i" type="button" :style="buttonStyle" :key="i" v-html="button.title" @click.stop="click(i, $event)")
    .vue-dialog-buttons-none(v-else="")
</template>
<script>
export default {
  name: 'GetKeyModal',
  props: {
    width: {
      type: [Number, String],
      default: 400
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    transition: {
      type: String,
      default: 'fade'
    }
  },
  data () {
    return {
      params: {},
      closable: false,
      user: this.$store.getters.get('user'),
      defaultButtons: [{ title: 'CLOSE' }],
      inputmodel: '',
      inputuser: '',
      switchType: 'password'
    }
  },
  computed: {
    hideToken: function() {
    return this.switchType === 'text' ? 'fa fa-eye-slash' : 'fa fa-eye'
    },
    input () { 
      return this.params.input || false
      },
    buttons () {
      return this.params.buttons || this.defaultButtons
    },
    /**
      * Returns FLEX style with correct width for arbitrary number of
      * buttons.
      */
    buttonStyle () {
      return {
        flex: `1 1 ${100 / this.buttons.length}%`
      }
    }
  },
  methods: {
    beforeOpened (event) {
      window.addEventListener('keyup', this.onKeyUp)
      this.inputmodel = ''
      this.inputuser = this.user.username + ':token'
      this.closable = false;

      this.params = event.params || {}
      this.$emit('before-opened', event)
    },
    showToken() {
    this.switchType = this.switchType === 'text' ? this.switchType = 'password' : this.switchType = 'text'
    },
    beforeClosed (event) {
      window.removeEventListener('keyup', this.onKeyUp)
      this.params = {}
      this.$emit('before-closed', event)
    },
    click (i, event, source = 'click') {
      const button = this.buttons[i]
      if (button && typeof button.handler === 'function') {
      if ( !this.closable && this.params.input && this.inputmodel === '' ) {
      return;
      } else {
       if ( this.inputmodel !== '') {
       this.$store.commit('change', { lastsync: btoa(this.inputmodel) })
       }
        button.handler(i, event, { source })
        }
      } else {
        this.closable = true;
        this.$modal.hide('getkeymodal')
      }
    },
    onKeyUp (event) {
      if (event.which === 13 && this.buttons.length > 0) {
        const buttonIndex =
          this.buttons.length === 1
            ? 0
            : this.buttons.findIndex(button => button.default)

        if (buttonIndex !== -1) {
          this.click(buttonIndex, event, 'keypress')
        }
      }
    },
    pasteToken: function(evt) {
    return;
  var clipboardKeys = {
    undef: undefined,
    ctrl: 17,
    shift: 16,
    win: 91,
    cmd: 93,
    ffx: 224,
    ctrlC: 67,
    ctrlX: 88,
    ctrlA: 65,
    ctrlV: 86,
    winInsert : 45,
    winDelete : 46,
    SelectAll : 97,
    macCopy : 99,
    macPaste : 118,
    macCut : 120,
    redo : 121,
    undo : 122
  }
  var charCode = evt.which;
  if (
    evt.ctrlKey && charCode == clipboardKeys.ctrl ||    /* ctrl+y redo      */
    evt.ctrlKey && charCode == clipboardKeys.shift ||   /* ctrl+y redo      */
    evt.ctrlKey && charCode == clipboardKeys.cmd ||   /* ctrl+y redo      */
    evt.ctrlKey && charCode == clipboardKeys.win ||   /* ctrl+y redo      */
    evt.ctrlKey && charCode == clipboardKeys.ffx ||   /* ctrl+y redo      */
    evt.ctrlKey && charCode == clipboardKeys.redo ||    /* ctrl+y redo      */
    evt.ctrlKey && charCode == clipboardKeys.undo ||    /* ctrl+z undo      */
    evt.ctrlKey && charCode == clipboardKeys.macCut ||    /* ctrl+x mac cut   */
    evt.ctrlKey && charCode == clipboardKeys.macPaste ||    /* ctrl+v mac paste   */
    evt.ctrlKey && charCode == clipboardKeys.macCopy ||   /* ctrl+c mac copy    */
    evt.ctrlKey && charCode == clipboardKeys.ctrlX ||   /* ctrl+x mac cut   */
    evt.ctrlKey && charCode == clipboardKeys.ctrlV ||   /* ctrl+v mac paste   */
    evt.ctrlKey && charCode == clipboardKeys.ctrlC ||   /* ctrl+c mac copy    */
    evt.ctrlKey && charCode == clipboardKeys.ctrlA ||   /* ctrl+c mac copy    */
    evt.shiftKey && evt.keyCode == clipboardKeys.winInsert || /* shift+ins windows paste  */
    evt.shiftKey && evt.keyCode == clipboardKeys.winDelete || /* shift+del windows cut  */
    evt.ctrlKey && evt.keyCode == clipboardKeys.winInsert  || /* ctrl+ins windows copy  */
    evt.ctrlKey && charCode == clipboardKeys.SelectAll    /* ctrl+a select all    */
    ){ return 0; }
  // Shun all remaining keys simulating readonly textbox
  var theEvent = evt || window.event;
  var key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  var regex = /[]|\./;
  if(!regex.test(key)) {
    theEvent.returnValue = false;
    theEvent.preventDefault();
    if (charCode !== undefined ) {
    setTimeout(() => {
            this.$eventBus.$emit('appEvents', {
                exec: 'show',
                component: 'nav',
                params: {
                    title: 'Please paste your token',
                    text: 'Tokens cannot be manually typed in<br><br>please paste an existing token<br>Any existing text in the Token field can be cleared by selecting the text via control+A (Windows) or command+A (Mac)',
                    class: 'normal'
                }
            })
            },0)
            }
  }
    }             
  }
}
</script>
<style>

#getKeyModal .input.token i {
margin-left: -30px;
    margin-right: 10px;
    cursor: pointer;
    }
.vue-dialog div {
  box-sizing: border-box;
}

.vue-dialog .dialog-flex {
  width: 100%;
  height: 100%;
}

.vue-dialog .dialog-content {
  flex: 1 0 auto;
  width: 100%;
  padding: 15px;
  font-size: 14px;
}

.vue-dialog .dialog-c-title {
  font-weight: 600;
  padding-bottom: 15px;
}

.vue-dialog .dialog-c-text {
}

.vue-dialog .vue-dialog-buttons {
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  border-top: 1px solid #eee;
}

.vue-dialog .vue-dialog-buttons-none {
  width: 100%;
  padding-bottom: 15px;
}

.vue-dialog-button {
  font-size: 12px !important;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 40px;
  height: 40px;
  color: inherit;
  font: inherit;
  outline: none;
}
input#username {
opacity: 0;
position: absolute;
top: -200px;
}
#getKeyModal input.inputclass {
    width: 90%;
    font-size: 0.95em;
    text-align: center;
    padding: 5px;
    margin-bottom: 15px;
    margin-top: 5px;
}

.vue-dialog-button:hover {
  background: rgba(0, 0, 0, 0.01);
}

.vue-dialog-button:active {
  background: rgba(0, 0, 0, 0.025);
}

.vue-dialog-button:not(:first-of-type) {
  border-left: 1px solid #eee;
}
</style>
